export function handleGenerateResult(result) {
  return result;
}

function parsePositionString(str) {
  if (!str) return [];
  return str
    .replace(/\]\[/g, "],[")
    .split("],[")
    .map((p) => p.replace(/\[|\]/g, "").split(",").map(Number))
    .filter((position) => position.length >= 4);
}

function stringifyPositions(positions) {
  return positions
    .map(([x, y, rotation, tableId, rawDatiRowNumber]) => {
      const datiRowNumber = Number(rawDatiRowNumber);

      return `[${x},${y},${rotation},${tableId},${
        Number.isInteger(datiRowNumber) && datiRowNumber > 0 ? datiRowNumber : 0
      }]`;
    })
    .join(",");
}

export function resultHandle({
  createdItems,
  placedRects,
  scope = "work",
  tableIds = [],
  colorIds = []
}) {
  const byItem = {};

  for (const rect of placedRects) {
    const itemId = rect.mainid ?? rect.itemId ?? rect.createdItem?.itemId;

    if (itemId == null) {
      console.warn("Placed rect itemId nélkül:", rect);
      continue;
    }

    const key = String(itemId);

    if (!byItem[key]) {
      byItem[key] = [];
    }

    byItem[key].push(rect);
  }

  return createdItems.map((item) => {
    const itemKey = String(item.itemId);
    const itemRects = byItem[itemKey] ?? [];

    // Only positions within the requested scope are replaced.
    if (
      scope === "colors" &&
      !colorIds.some((colorId) => String(colorId) === String(item.color?.colorId))
    ) {
      return item;
    }

    /*
     * Ez csak a tablePosition megjelenítési sorrendje.
     * A Dati-kapcsolatot nem ebből számítjuk, hanem
     * minden rect saját datiRowNumber mezőjéből.
     */
    const sortedRects = [...itemRects].sort(
      (a, b) =>
        Number(a.rootId ?? 0) - Number(b.rootId ?? 0) ||
        Number(a.ypos ?? 0) - Number(b.ypos ?? 0) ||
        Number(a.xpos ?? 0) - Number(b.xpos ?? 0) ||
        Number(a.localid ?? 0) - Number(b.localid ?? 0)
    );
    const newPositions = sortedRects.map((rect) => {
      const datiRowNumber = Number(rect.datiRowNumber);

      return [
        Number(Number(rect.xpos ?? 0).toFixed(1)),
        Number(Number(rect.ypos ?? 0).toFixed(1)),
        rect.rotated ? 1 : 0,
        rect.id ?? -1,
        Number.isInteger(datiRowNumber) && datiRowNumber > 0 ? datiRowNumber : 0
      ];
    });

    // WORK: teljes felülírás
    if (scope === "work") {
      return {
        ...item,
        tablePosition: stringifyPositions(newPositions)
      };
    }

    // COLORS vagy TABLES: meglévő pozíciók megtartása
    const originalPositions = parsePositionString(item.tablePosition);

    let filteredOriginal = originalPositions;

    if (scope === "tables") {
      const selectedTableIds = new Set(
        tableIds.map((tableId) => String(tableId))
      );

      filteredOriginal = originalPositions.filter(
        ([, , , tableId]) => !selectedTableIds.has(String(tableId))
      );
    }

    if (scope === "colors") {
      filteredOriginal = [];
    }

    const mergedPositions = [...filteredOriginal, ...newPositions];

    return {
      ...item,
      tablePosition: stringifyPositions(mergedPositions)
    };
  });
}
